import { Box, Button, DialogContent, Grid, IconButton } from '@material-ui/core';
import {
  ClapperBoardIcon,
  // CloseIcon
  DocumentFileIcon,
  FullBodyIcon,
  HeadshotIcon,
  MicrophoneIcon,
  OtherImagesIcon,
} from '@room-match/shared-ui-components';
import React, { useState } from 'react';
import CloseIcon from 'shared/components/Icon/CloseIcon'; // Use talent app level folder Close Icon - Jerome
import StyledDialog from 'shared/elements/StyledDialog/StyledDialog';
import { getErrorMessage } from 'shared/utils/room-shared';
import { AudioModal } from '../AudioModal';
import { AuditionSelfieModal } from '../AuditionSelfieModal';
import SlateModal from '../SlateModal/SlateModal';
import { CustomTextInput, TextGreyColor, TextSwitchColor, useStyles } from './SizeCardModal.styles';

type Props = {
  open: boolean;
  onClose: () => void;
  label: string;
  info: string;
  onUpload: VoidFunction;
  openMediaBin: VoidFunction;
  type: 'Image' | 'Video' | 'Audio' | 'File' | 'Other Image';
  hasImage: boolean;
  hasVideo: boolean;
  hasAudio: boolean;
  setTag: (tag: string) => void;
};
const SizeCardModal: React.FC<Props> = ({
  open,
  onClose,
  label,
  info,
  onUpload,
  openMediaBin,
  type,
  hasImage,
  hasVideo,
  hasAudio,
  setTag,
}) => {
  const classes = useStyles();

  const [slateModalOpen, setSlateModalOpen] = useState(false);
  const [auditionSelfieModalOpen, setAuditionSelfieModalOpen] = useState(false);
  const [audioModalOpen, setAudioModalOpen] = useState(false);
  const [tag, settag] = useState('');

  return (
    <StyledDialog open={open} onClose={onClose} className={classes.root} style={{ zIndex: 9998 }}>
      <DialogContent className={classes.content}>
        <Box component="div" className={classes.close}>
          <IconButton size="small" onClick={() => onClose()}>
            <CloseIcon style={{ fontSize: 16 }} />
          </IconButton>
        </Box>
        <Grid item>
          {label === 'Audition Selfie' || label === 'Images' ? (
            <HeadshotIcon className={classes.icon} />
          ) : label === 'Full Body' ? (
            <FullBodyIcon className={classes.icon} />
          ) : type === 'Audio' ? (
            <MicrophoneIcon className={classes.icon} />
          ) : type === 'File' ? (
            <DocumentFileIcon className={`${classes.icon} documentIcon`} />
          ) : label.includes('Other Image') ? (
            <OtherImagesIcon style={{ height: 40, width: 40 }} />
          ) : (
            <ClapperBoardIcon className={classes.icon} />
          )}
        </Grid>
        <Grid item>
          {label ? (
            <TextSwitchColor size={24} weight={500}>
              {label}
            </TextSwitchColor>
          ) : (
            <CustomTextInput
              value={tag}
              onChange={(e) => {
                setTag(e.target.value);
                settag(e.target.value);
              }}
              placeholder="Media Name"
              // error={tag === ''}
              // errorMessage="Media name required"
              errorMessage={getErrorMessage(tag === '', 'Media name required')}
            />
          )}
        </Grid>
        <Grid item>
          <TextGreyColor>{info ? info : 'N/A'}</TextGreyColor>
        </Grid>
        <Grid item className={classes.buttonContainer}>
          <Button
            variant="contained"
            // color="primary"
            fullWidth
            className={classes.buttonCls}
            color="primary"
            disabled={label === '' ? tag === '' : false}
            onClick={onUpload}
          >
            Upload
          </Button>
          {type !== 'File' && (
            <Button
              variant="outlined"
              fullWidth
              className={`${classes.buttonCls} ${classes.outlinedButtonCls} ${classes.uploadButton}`}
              // className={`${classes.buttonCls} ${classes.outlinedButtonCls}`}
              onClick={openMediaBin}
              disabled={
                // (type === 'Image' ? !hasImage : type === 'Audio' ? !hasAudio : !hasVideo) ||
                label === '' ? tag === '' : false
              }
            >
              Media Bin
            </Button>
          )}
        </Grid>
      </DialogContent>
      <SlateModal open={slateModalOpen} onClose={() => setSlateModalOpen(false)} />
      <AudioModal open={audioModalOpen} onClose={() => setAudioModalOpen(false)} />
      <AuditionSelfieModal open={auditionSelfieModalOpen} onClose={() => setAuditionSelfieModalOpen(false)} />
    </StyledDialog>
  );
};

export default SizeCardModal;
